import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { NAVIGATION_LINKS } from '../constants/navigation';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleLinkClick = () => {
    setIsOpen(false);
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      return () => document.removeEventListener('keydown', handleEscape);
    }
  }, [isOpen]);

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo" onClick={handleLinkClick}>
          <img src="/images/logos/cornerLogo.png" alt="Travel Mhor" className="nav-logo-img" />
        </Link>
        <div
          id="nav-menu"
          className={isOpen ? "nav-menu active" : "nav-menu"}
          role="navigation"
          aria-label="Main navigation"
        >
          {NAVIGATION_LINKS.map((link) => (
            <Link key={link.path} to={link.path} className="nav-link" onClick={handleLinkClick}>
              {link.label}
            </Link>
          ))}
        </div>
        <button
          className="nav-toggle"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle navigation menu"
          aria-expanded={isOpen}
          aria-controls="nav-menu"
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;